import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { router } from './app/router';
import { SessionProvider } from './features/session/SessionProvider';
import { tokens } from './lib/api/tokens';
import { createQueryClient } from './lib/queryClient';
import './i18n';
import './features/settings/installEvent'; // starts listening for the browser's install offer at boot
import './styles/index.css';

// Start the chunk the first screen will need now, instead of after the session check resolves: the shell for a
// returning user, the sign-in form (and its form libraries, which the entry bundle leaves out) for a visitor.
void (tokens.refresh() ? import('./components/shell/AppShell') : import('./features/auth/LoginPage'));

const queryClient = createQueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
